<template>
  <div class="col px-0">
    <v-overlay :value="loading">
      <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>

    <div class="text-subtitle-1 text-sm-h6 text-md-h5 font-weight-bold text-center">
      Relatório WMS
    </div>

    <v-card>
      <v-card-title>
        <span>Filtros</span>
      </v-card-title>
      <v-card-text>
        <v-row>
          <v-col cols="12" sm="12" md="7">
            <v-autocomplete
              v-model="storageIds"
              label="Estoque(s)"
              :items="storageList"
              item-value="id"
              item-text="name"
              clearable
              @click:clear="storageIds = []"
              :loading="storageListLoading"
              multiple
              chips
              dense
              deletable-chips
              hint="Selecione os estoques desejados"
              persistent-hint
            />
          </v-col>

          <v-col cols="12" sm="12" md="7">
            <v-autocomplete
              v-model="wmsIds"
              label="WMS(s)"
              :items="wmsList"
              item-value="id"
              item-text="name"
              clearable
              @click:clear="wmsIds = []"
              :loading="storageListLoading"
              multiple
              chips
              dense
              deletable-chips
              hint="Selecione os WMSs desejados"
              persistent-hint
            />
          </v-col>

          <v-col cols="12" sm="12" md="7">
            <v-autocomplete
              v-model="buildingIds"
              label="Módulo(s)"
              :items="buildingList"
              item-value="id"
              item-text="name"
              clearable
              @click:clear="buildingIds = []"
              :loading="storageListLoading"
              multiple
              chips
              dense
              deletable-chips
              hint="Selecione os módulos/edifícios desejados"
              persistent-hint
            />
          </v-col>

          <v-col cols="12" sm="12" md="7">
            <v-autocomplete
              v-model="levelIds"
              label="Nível(s)"
              :items="levelList"
              item-value="id"
              item-text="name"
              clearable
              @click:clear="levelIds = []"
              :loading="storageListLoading"
              multiple
              chips
              dense
              deletable-chips
              hint="Selecione os níveis/andares desejados"
              persistent-hint
            />
          </v-col>

          <v-col cols="12" sm="12" md="7">
            <v-autocomplete
              v-model="boxIds"
              label="Box(es)"
              :items="boxList"
              item-value="id"
              item-text="name"
              clearable
              @click:clear="boxIds = []"
              :loading="storageListLoading"
              multiple
              chips
              dense
              deletable-chips
              hint="Selecione os boxes/vãos desejados"
              persistent-hint
            />
          </v-col>          

          <v-col cols="12" sm="6" md="2">
            <v-btn 
              @click="loadStorageInventoryReport"              
              class="mt-2"
            >
              <v-icon left>mdi-magnify</v-icon>
              Filtrar
            </v-btn>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>

    <div>
      <BasePrint
        printableElementId="storageInventoryReportTable"
        printButtonLabel="Imprimir"
        printTitle="Relatório WMS"
        @start-printing="printing = loading = true"
        @stop-printing="printing = loading = false"
        v-if="storageInventory"
        class="mt-3"
      />
    </div>

    <div id="storageInventoryReportTable">
      
      <v-row>
        <v-col cols="12" v-for="storage in storageInventory" :key="storage.name+'storage'">
            <v-card>
              <v-card-title>
                <span>{{storage.name}}</span>
              </v-card-title>

              <v-col cols="12" v-for="shelf in storage.shelves" :key="shelf.name+'shelf'">
                <v-card>
                  <v-card-title>
                    <span>{{shelf.name}}</span>
                  </v-card-title>

                  <v-col cols="12" v-for="building in shelf.buildings" :key="building.name+'building'">
                    <v-card>
                      <v-card-title>
                        <span>{{building.name}}</span>
                      </v-card-title>

                        <v-col cols="12" v-for="level in building.levels" :key="level.name+'level'">
                          <v-card>
                            <v-card-title>
                              <span>{{level.name}}</span>
                            </v-card-title>

                                          <v-col cols="12" v-for="box in level.boxes" :key="box.name+'box'">
                            
                                              <v-card-text>
                                                <v-row>
                                                  <v-col cols="12" sm="12" md="12">
                                                    <BaseIndex
                                                      ref="baseIndex"
                                                      :loading="loading"
                                                      :pageLoading="pageLoading"
                                                      :table-headers="tableHeaders"
                                                      :table-items="box.items"
                                                      :indexNested="true"
                                                      :disablePagination="true"
                                                      :containTopToolbar="false"
                                                      :maskFields="maskFields"
                                                      :hasTableTitle="false"
                                                      :hasTopMenu="false"
                                                      :modelNamePlural="box.name"
                                                    />                    
                                                  </v-col>
                                                </v-row>
                                              </v-card-text>                              
                                          </v-col>

                          </v-card>
                        </v-col>
                    </v-card>
                  </v-col>

                </v-card>
              </v-col>


            </v-card>
        </v-col>
      </v-row>
    </div>
    
  </div>
</template>

<script>
import gql from 'graphql-tag'
import BaseIndex from "@shared_components/base_index.vue";
import DateRangeField from "@shared_components/date_range_field.vue"
import BasePrint from "@shared_components/base_print.vue";

export default {
  data() {
    return {
      tableItems: [],
      storageInventory: null,
      pageLoading: false,
      loading: false,
      showEmptyItems: false,
      storageListLoading: false,
      storageList: [],
      storageIds: [],

      wmsListLoading: false,
      wmsList: [],
      wmsIds: [],

      buildingList: [],
      buildingIds: [],

      levelList: [],
      levelIds: [],

      boxList: [],
      boxIds: [],

      tableHeaders: [
        { text: "Item", align: "left", sortable: true, value: "name" },
        // { text: "Grupo", align: "left", sortable: true, value: "group" },
        { text: "Embalagem", align: "left", sortable: true, value: "packagingName" },
        { text: "Qtd. em Estoque", align: "left", sortable: true, value: "quantity" },
        // { text: "R$ Médio Total", align: "left", sortable: true, value: "availableTotalPrice" },
        { text: "Qtd. em Inventário", align: "left", sortable: true, value: "inventoryQuantity" },
        // { text: "Localização", align: "left", sortable: true, value: "inventoryLocation" },
        // { text: "deleted", value: "_destroy", align: ' d-none', sortable: false, filter: value => value ? !value : true },
        // { text: "Ações", value: "action", sortable: false }
      ],
      maskFields: [
        { field: 'availableQuantity', mask: 'number_row_unit', unit: 'unit' },
        { field: 'inventoryQuantity', mask: 'blank_field_row_unit', unit: 'unit' },
        // { field: 'inventoryLocation', mask: 'blank_field' },
        { field: 'averageUnitPrice', mask: 'currency' },
        { field: 'availableTotalPrice', mask: 'currency' },
      ]
    };
  },
  watch: {
    storageIds: function(){
      if (this.storageIds.length > 0){
        this.loadAllStorageShelves();
      }
    },
    wmsIds: function(){
      if (this.wmsIds.length > 0){
        this.loadAllStorageBuildings();
      }
    },
    buildingIds: function(){
      if (this.buildingIds.length > 0){
        this.loadAllBuildingLevels();
      }
    },
    levelIds: function(){
      if (this.levelIds.length > 0){
        this.loadAllBuildingLevelBoxes();
      }
    },
  },
  props: {
  },
  components: {
    BaseIndex: BaseIndex,
    DateRangeField: DateRangeField,
    BasePrint: BasePrint,
  },
  created() {
    this.loadAllStorages();
  },
  mounted() { 
  },
  computed: {
    // tableHeaders: function () { }
  },
  methods: {
    loadStorageInventoryReport: function() {
      this.loading = true;
      this.$apollo
        .query({
          query: LOAD_STORAGE_INVENTORY_REPORT,
          variables: {
            storageIds: this.storageIds,
            wmsIds: this.wmsIds,
            buildingIds: this.buildingIds,
            levelIds: this.levelIds,
            boxIds: this.boxIds,
            // showEmptyItems: this.showEmptyItems
          },
          fetchPolicy: "no-cache"
        })
        .then(response => {
          this.storageInventory = response.data.accountContext.inventoryWmsReport;
          console.log("stoi", this.storageInventory);
          // console.log("storageInventory", this.storageInventory);
        })
        .catch(response => console.log(response))
        .finally(() => (this.loading = false));
    },
    loadAllStorages: function() {
      this.storageListLoading = true;
      this.$apollo
        .query({
          query: LOAD_ALL_STORAGES_QUERY,
          // variables: {
          //   harvestId: this.harvestId,
          //   cultureId: this.cultureId
          // },
          fetchPolicy: "no-cache"
        })
        .then(response => {
          this.storageList = response.data.accountContext.allStorages;
          this.storageIds = [];
        })
        .catch(response => console.log(response))
        .finally(() => (this.storageListLoading = false));
    },

    loadAllStorageShelves: function() {
      this.storageListLoading = true;
      this.$apollo
        .query({
          query: LOAD_ALL_STORAGE_SHELVES_QUERY,
          variables: {
            storageIds: this.storageIds,
          },
          fetchPolicy: "no-cache"
        })
        .then(response => {
          this.wmsList = response.data.accountContext.allStorageShelves;
          this.wmsIds = [];
        })
        .catch(response => console.log(response))
        .finally(() => (this.storageListLoading = false));
    },
    loadAllStorageBuildings: function() {
      this.storageListLoading = true;
      this.$apollo
        .query({
          query: LOAD_ALL_STORAGE_BUILDINGS_QUERY,
          variables: {
            shelfIds: this.wmsIds,
          },
          fetchPolicy: "no-cache"
        })
        .then(response => {
          this.buildingList = response.data.accountContext.allStorageBuildings;
          this.buildingIds = [];
        })
        .catch(response => console.log(response))
        .finally(() => (this.storageListLoading = false));
    },
    loadAllBuildingLevels: function() {
      this.storageListLoading = true;
      this.$apollo
        .query({
          query: LOAD_ALL_BUILDING_LEVELS_QUERY,
          variables: {
            buildingIds: this.buildingIds,
          },
          fetchPolicy: "no-cache"
        })
        .then(response => {
          this.levelList = response.data.accountContext.allBuildingLevels;
          this.levelIds = [];
        })
        .catch(response => console.log(response))
        .finally(() => (this.storageListLoading = false));
    },
    loadAllBuildingLevelBoxes: function() {
      this.storageListLoading = true;
      this.$apollo
        .query({
          query: LOAD_ALL_BUILDING_LEVEL_BOXES_QUERY,
          variables: {
            levelIds: this.levelIds,
          },
          fetchPolicy: "no-cache"
        })
        .then(response => {
          this.boxList = response.data.accountContext.allBuildingLevelBoxes;
          this.boxIds = [];
        })
        .catch(response => console.log(response))
        .finally(() => (this.storageListLoading = false));
    },
  }
};



const LOAD_STORAGE_INVENTORY_REPORT = gql `
query ($storageIds: [ID!], $wmsIds: [ID!], $buildingIds: [ID!], $levelIds: [ID!], $boxIds: [ID!]){
  accountContext {
    inventoryWmsReport(storageIds: $storageIds, wmsIds: $wmsIds, buildingIds: $buildingIds, levelIds: $levelIds, boxIds: $boxIds)
  }
}
`;

const LOAD_ALL_STORAGES_QUERY = gql `
  {
    accountContext {
      allStorages{
        id
        name
      }
    }
  }
`;

const LOAD_ALL_STORAGE_SHELVES_QUERY = gql `
  query($storageIds: [ID!]){
    accountContext {
      allStorageShelves(storageIds: $storageIds){
        id
        name
      }
    }
  }
`;

const LOAD_ALL_STORAGE_BUILDINGS_QUERY = gql `
  query($shelfIds: [ID!]){
    accountContext {
      allStorageBuildings(shelfIds: $shelfIds){
        id
        name
      }
    }
  }
`;

const LOAD_ALL_BUILDING_LEVELS_QUERY = gql `
  query($buildingIds: [ID!]){
    accountContext {
      allBuildingLevels(buildingIds: $buildingIds){
        id
        name
      }
    }
  }
`;

const LOAD_ALL_BUILDING_LEVEL_BOXES_QUERY = gql `
  query($levelIds: [ID!]){
    accountContext {
      allBuildingLevelBoxes(levelIds: $levelIds){
        id
        name
      }
    }
  }
`;

</script>

<style scoped> 
</style>
